<template>
    <div class="">
        <div class="d-sm-flex align-items-center justify-content-between mb-2">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item">
                        <router-link to="/dashboard">Dashboard</router-link>
                    </li>
                    <li class="breadcrumb-item" aria-current="page"><router-link to="/trips">Trips</router-link></li>
                    <li class="breadcrumb-item active" aria-current="page">Trip View</li>
                </ol>
                <h4 class="main-title mb-0">Trips</h4>
            </div>
            <router-link to="/trips" type="submit" class="btn btn-primary"><i class="ri-list-check fs-18 lh-1"></i> Trips</router-link>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="card card-one">
                    <div class="card-header" style="border-bottom: none !important;">
                        <!-- <h6 class="card-title">View Trip</h6> -->
                        <div class="nav nav-tabs mb-0" id="nav-tab" role="tablist">
                            <span>
                                <button class="nav-link" :class="{active:active}" @click="getBasicDetails()">Basic Information</button>
                            </span>
                            <span v-for="trip_stage,key in trip_stages" :key="key">
                                <button v-if="trip_stage_active" :class="{active:trip_stage.active}" class="nav-link" @click="getTripChecks(trip_stage)">{{ trip_stage.stage_name }}</button>
                                <button v-else class="nav-link" @click="getTripChecks(trip_stage)">{{ trip_stage.stage_name }}</button>
                            </span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12">
                                <TripChecks :item="trip_checks" :basicDetail="trip" :status="basic_detail_status" @tripStages="tripStages" :trip_attachments="trip_attachments" :checkAttachmentStatus=false :loading_type_status="loading_type_status"></TripChecks>
                                <div class="row g-2">
                                    <div class="col-md-3" v-for="trip_attachment, key in trip_attachments" :key="key">
                                        <div>
                                            <div class="card-header d-flex justify-content-between">
                                                <h6 class="card-title">Image</h6>
                                            </div>
                                            <div class="card-body">
                                                <img class="mb-2" width="100" height="100" :src="trip_attachment.attachment_path" />
                                            </div>
                                            <div class="card-footer">
                                                <a :href="$store.getters.apiUrl+'downloadImage?filename='+trip_attachment.attachment_name" target="_blank" class="btn btn-sm btn-primary">
                                                    Download<i class="ri-download-line fs-18 lh-1"></i>
                                                </a>
                                                <button v-if="$store.getters.user.role.role_code=='ADMIN'"
                                                        class="btn btn-sm btn-outline-danger" style="margin-left: 5px;"
                                                        @click="confirmAndDelete(trip_attachment)">
                                                    Delete
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    import TripChecks from "@/components/TripChecks.vue";
    export default {
        components: {
            Pagination,
            TripChecks,
        },
        data() {
            return {
                trip: {
                    trip_id: "",
                },
                trip_check_id: "",

                trips: [],
                trip_stages: [],
                trip_checks: [],
                trip_attachments: [],
                errors: [],
                status: true,
                active: false,
                basic_detail_status: true,
                active: true,
                trip_stage_active: false,
                loading_type_status:false
                
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.trip.trip_id = to.params.trip_id;
                let uri = { uri: "getTrip", data: vm.trip };
                vm.$store
                    .dispatch("post", uri)
                    .then(function (response) {
                        vm.trip = response.data.data;
                        vm.trip_stages = response.data.data.trip_stages
                        if (vm.trip_stages.length) {
                            vm.trip_stage_id = vm.trip_stages[0].trip_stage_id;
                            vm.loading_type_status = true
                        }
                        vm.getBasicDetails();
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            });
        },
        mounted() {
            // this.getTrips();
        },

        methods: {
            tripStages(trip_stages){
                this.trip_stages = trip_stages
                this.loading_type_status = true
            },
            getTripChecks(trip_stage) {
                let vm = this;
                vm.active = false;
                vm.trip_stages.map(function (el) {
                    el.active = false;
                });
                vm.trip_stage_active = true;
                trip_stage.active = true;

                let uri = { uri: "getTripChecks", data: { trip_stage_id: trip_stage.trip_stage_id } };
                vm.$store
                    .dispatch("post", uri)
                    .then(function (response) {
                        
                        vm.trip_checks = response.data.data;
                        vm.trip_attachments = response.data.trip_attachments;
                        vm.basic_detail_status = false;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            getBasicDetails() {
                let vm = this;
                vm.trip_stage_active = false;
                vm.active = true;
                vm.trip_attachments = [];
                let uri = { uri: "getTrip", data: vm.trip };
                vm.$store
                    .dispatch("post", uri)
                    .then(function (response) {
                        vm.trip = response.data.data;
                        vm.basic_detail_status = true;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            async confirmAndDelete(attachment){
                const ok = window.confirm('Delete this image permanently? This action cannot be undone.');
                if(!ok){ return; }
                try{
                    const axios = (await import('axios')).default;
                    await axios.post(this.$store.getters.apiUrl + 'deleteTripAttachment', {
                        trip_attachment_id: attachment.trip_attachment_id
                    }, {
                        headers: { Authorization: "Bearer" + " " + this.$store.getters.token }
                    });
                    // Remove from local list
                    this.trip_attachments = this.trip_attachments.filter(a => a.trip_attachment_id !== attachment.trip_attachment_id);
                    this.$store.dispatch('success', 'Image deleted');
                }catch(err){
                    const msg = err?.response?.data?.message || 'Failed to delete image';
                    this.$store.dispatch('error', msg);
                }
            }
        },
    };
</script>
<style scoped>
    .no-border-bottom {
        border-bottom: 2px solid white;
    }
</style>
